"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function AIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("polygon", { points: "13.792 1.999 9.741 1.999 13.33 13.462 9.971 13.462 9.971 16.847 14.331 16.847 15.946 22.001 20.023 22.001 13.792 1.999" }),
        react_1.default.createElement("rect", { x: "7.158", y: ".307", width: "1.408", height: "23.387" })));
}
exports.default = AIcon;
